import axios from '../axios';
import Vue from 'vue';
import * as constants from '../constants';

export default {
  namespaced: true,

  state: {
    data: [],
    employee: {}
  },

  actions: {
    LOAD({ commit }, { filter }) {
      let params = {};
      if (filter) {
        for (let key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/employees`, { params })
          .then(response => response.data)
          .then(response => {
            commit('EMPLOYEES', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    LOAD_ONE({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/employees/${id}`)
          .then(response => response.data)
          .then(response => {
            commit('EMPLOYEE', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/employees/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/employees/${data.id}`, data)
          .then(response => {
            commit('EDIT', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${constants.SERVER_URL}/api/employees/`, data)
          .then(response => {
            commit('ADD', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }
  },

  mutations: {
    EMPLOYEES(state, payload) {
      state.data = payload;
    },

    EMPLOYEE(state, payload) {
      state.employee = payload;
    },

    EDIT(state, payload) {
      const index = state.data.findIndex(employee => employee.id === payload.id);
      if (index > -1) {
        Vue.set(state.data, index, payload);
      }
    },

    ADD(state, payload) {
      state.data.unshift(payload);
    },

    DELETE(state, id) {
      const index = state.data.findIndex(item => item.id === id);
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {

  }
};



// WEBPACK FOOTER //
// ./src/store/employees.js